module.exports = __webpack_public_path__ + "static/media/tour iconG.2331e5ea.svg";